(() => {
  const config = window.gratisGeschenk;
  if (!config || !window.theme || !theme.pubsub) return;

  const PROPERTY = '_gratis_geschenk';
  const SOURCE = 'gratis-geschenk';
  let busy = false;
  let pending = false;
  let addFailed = false;

  const isGiftLine = (item) => Boolean(item.properties && item.properties[PROPERTY]);

  const bundledSections = () => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
    return sections;
  };

  const postJson = (url, body) =>
    fetch(url, { ...theme.utils.fetchConfig(), body: JSON.stringify(body) }).then((response) => response.json());

  const getCart = () =>
    fetch(`${theme.routes.cart_url}.js`, { ...theme.utils.fetchConfig('json', 'GET') }).then((response) => response.json());

  const publish = (cart) => {
    theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cart });
  };

  const addGift = async () => {
    const sections = bundledSections();
    const result = await postJson(theme.routes.cart_add_url, {
      items: [{ id: config.variantId, quantity: 1, properties: { [PROPERTY]: '1' } }],
      sections
    });

    if (result.status) {
      addFailed = true;
      return;
    }

    const cart = await getCart();
    cart.sections = result.sections;
    publish(cart);
  };

  const setGiftQuantity = async (key, quantity) => {
    const cart = await postJson(theme.routes.cart_change_url, { id: key, quantity, sections: bundledSections() });
    if (!cart.status) publish(cart);
  };

  const reconcile = async (cart) => {
    if (!cart || cart.errors || !Array.isArray(cart.items)) return;

    if (busy) {
      pending = true;
      return;
    }

    const giftLine = cart.items.find(isGiftLine);
    const subtotal = cart.items
      .filter((item) => !isGiftLine(item))
      .reduce((sum, item) => sum + item.final_line_price, 0);
    const qualifies = subtotal >= config.threshold;

    let action = null;
    if (giftLine && (!qualifies || giftLine.variant_id !== config.variantId)) {
      action = () => setGiftQuantity(giftLine.key, 0);
    }
    else if (giftLine && giftLine.quantity !== 1) {
      action = () => setGiftQuantity(giftLine.key, 1);
    }
    else if (!giftLine && qualifies && !addFailed) {
      action = addGift;
    }

    if (!action) return;

    busy = true;
    try {
      await action();
    }
    catch (error) {
      console.error(error);
    }
    finally {
      busy = false;
    }

    if (pending) {
      pending = false;
      reconcile(await getCart());
    }
  };

  theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.source === SOURCE) return;
    reconcile(event.cart);
  });

  getCart().then(reconcile).catch((error) => console.error(error));
})();
